import axiosInstance from "./api_helper";

const comptabiliteService = {
    
    // Get list of accounts for search
    getComptes: async (search = '') => {
        const params = new URLSearchParams();
        if (search) params.append('query', search);
        return axiosInstance.get(`/api/comptes/search?${params.toString()}`);
    },

    // Get client auxiliary accounts
    getClientAccounts: async () => {
        return axiosInstance.get(`/api/comptes-auxiliaires/clients`);
    },

    // Get supplier auxiliary accounts
    getSupplierAccounts: async () => {
        return axiosInstance.get(`/api/comptes-auxiliaires/fournisseurs`);
    },

    // Get accounts for specific client
    getClientAccountsByClientId: async (clientId) => {
        return axiosInstance.get(`/api/comptabilite/releves/releve/${clientId}`);
    },

    // Get accounts for specific supplier
    getSupplierAccountsByFournisseurId: async (fournisseurId) => {
        return axiosInstance.get(`/api/comptes-auxiliaires/fournisseurs/${fournisseurId}`);
    },

    // Get account statement for a specific account
    getReleveCompte: async (numeroCompte, dateDebut = null, dateFin = null) => {
        const params = new URLSearchParams();
        if (dateDebut) params.append('dateDebut', dateDebut);
        if (dateFin) params.append('dateFin', dateFin);
        
        return axiosInstance.get(`/api/comptabilite/releves/compte/${numeroCompte}?${params.toString()}`);
    },

    // Get account entries (paginated)
    getEcrituresCompte: async (numeroCompte, options = {}) => {
        const { dateDebut, dateFin, page = 0, size = 20, sort = 'dateEcriture', direction = 'desc' } = options;
        const params = new URLSearchParams();
        
        if (dateDebut) params.append('dateDebut', dateDebut);
        if (dateFin) params.append('dateFin', dateFin);
        params.append('page', page);
        params.append('size', size);
        params.append('sort', sort);
        params.append('direction', direction);
        
        return axiosInstance.get(`/api/comptabilite/releves/ecritures/compte/${numeroCompte}?${params.toString()}`);
    },

    // Get journal entries (paginated)
    getEcrituresJournal: async (codeJournal, options = {}) => {
        const { dateDebut, dateFin, page = 0, size = 20 } = options;
        const params = new URLSearchParams();
        
        if (dateDebut) params.append('dateDebut', dateDebut);
        if (dateFin) params.append('dateFin', dateFin);
        params.append('page', page);
        params.append('size', size);
        
        return axiosInstance.get(`/api/comptabilite/releves/ecritures/journal/${codeJournal}?${params.toString()}`);
    },

    // Get account balances
    getSoldesComptes: async (classeCompte = null, dateArrete = null) => {
        const params = new URLSearchParams();
        if (classeCompte) params.append('classeCompte', classeCompte);
        if (dateArrete) params.append('dateArrete', dateArrete);
        
        return axiosInstance.get(`/api/comptabilite/releves/soldes?${params.toString()}`);
    },

    // Get trial balance
    getBalanceComptable: async (dateDebut = null, dateFin = null) => {
        const params = new URLSearchParams();
        if (dateDebut) params.append('dateDebut', dateDebut);
        if (dateFin) params.append('dateFin', dateFin);
        
        return axiosInstance.get(`/api/comptabilite/releves/balance?${params.toString()}`);
    },

    // Get general ledger
    getGrandLivre: async (dateDebut = null, dateFin = null, classeCompte = null) => {
        const params = new URLSearchParams();
        if (dateDebut) params.append('dateDebut', dateDebut);
        if (dateFin) params.append('dateFin', dateFin);
        if (classeCompte) params.append('classeCompte', classeCompte);
        
        return axiosInstance.get(`/api/comptabilite/releves/grand-livre?${params.toString()}`);
    },

    // Get accounting summary by period
    getSyntheseComptable: async (dateDebut = null, dateFin = null) => {
        const params = new URLSearchParams();
        if (dateDebut) params.append('dateDebut', dateDebut);
        if (dateFin) params.append('dateFin', dateFin);
        
        return axiosInstance.get(`/api/comptabilite/releves/synthese?${params.toString()}`);
    }
};

export default comptabiliteService;
